import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'src/redux/rootReducer';
import { Select, Input, Text, View } from 'src/components/common';
import { getVacantEmployeesAsync } from 'src/redux/employees/actions';
import { EmployeeInfo, WeeklyTimesheet } from 'src/redux/timesheet/types';
import { InitialEmployeeInfo } from 'src/redux/timesheet/reducer';
import { setSelectedTimesheet } from 'src/redux/timesheet/actions';
import { getDatePayload } from 'src/utils/momentUtils';

const Sidebar: React.FC<Props> = ({ timesheetData, onSearchEmployee, onSetSelectedTimesheet }) => {
  const { employeeInfo } = timesheetData;
  const isUpdateTimesheet = !!timesheetData.id;
  const [vacantEmployees, setVacantEmployees] = useState([]);

  useEffect(() => {
    onSearchEmployee({
      startDate: getDatePayload(timesheetData.startDate),
      endDate: getDatePayload(timesheetData.endDate),
      callback: res => {
        const vacantEmployees =
          res.employees.map(employee => ({
            ...employee,
            label: `ID: ${employee.employeeId} - ${employee.lastName}, ${employee.firstName}`,
            value: employee,
          })) || [];

        setVacantEmployees(vacantEmployees || []);
      },
    });
    // eslint-disable-next-line
  }, []);

  const handleSelectUser = (_name, newValue) => {
    const newEmployee: EmployeeInfo = newValue
      ? {
          id: newValue.id,
          name: `${newValue.lastName}, ${newValue.firstName}`,
          employeeId: newValue.employeeId,
          rate: newValue.rate,
          trade: newValue.trade,
          level: newValue.level,
        }
      : InitialEmployeeInfo;
    setEmployeeInfo(newEmployee);
  };

  const setEmployeeInfo = (newEmployee: EmployeeInfo) => {
    const updateValue: WeeklyTimesheet = {
      ...timesheetData,
      employeeInfo: newEmployee,
    };
    onSetSelectedTimesheet(updateValue);
  };

  return (
    <div>
      <View className="cmp-sidebar__container ctn-timesheet-weekly__sidebar--container">
        <Text size={20}>General Info</Text>
        <Text className="mt-16" style={{ fontWeight: 'bold' }}>
          Week
        </Text>
        <Text className="mb-16">{`${timesheetData.startDate} - ${timesheetData.endDate}`}</Text>
        {!isUpdateTimesheet && (
          <Select
            creatable={false}
            isClearable={true}
            className="mb-16"
            label={''}
            name={'employee'}
            placeholder="Select Employee ID/Name"
            options={vacantEmployees}
            value={employeeInfo?.id ? employeeInfo : null}
            onBlur={() => {}}
            errorMessage={''}
            onChange={handleSelectUser}
          />
        )}
        <Input className="mb-16" name={'employeeId'} label="Employee ID" disabled value={employeeInfo.employeeId} />
        <Input className="mb-16" name={'employeeName'} label="Employee Name" value={employeeInfo.name} disabled />
        <Input className="mb-16" name={'trade'} label="Trade" disabled value={employeeInfo.trade} />
        {/* <Input className="mb-16" name={'rate'} label="Rate" disabled value={Number(employeeInfo.rate).toFixed(2)} /> */}
        <Input name={'level'} label="Level" disabled value={employeeInfo.level} />
      </View>
    </div>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const mapStateToProps = (state: IRootState) => ({
  timesheetData: state.timesheet.weeklyTableData,
});

const mapDispatchToProps = {
  onSearchEmployee: getVacantEmployeesAsync.request,
  onSetSelectedTimesheet: setSelectedTimesheet,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
